import styles from './styles.module.scss';
import { SidebarItemInner, SidebarItemSeason } from './index.jsx';

const SidebarItem = ({ t, title, isActive, isDisabled, isAiEnabled, isSoilSensor, showAddSeasonButton, onClickAddSeason }) => {
  return (
    <div
      className={`
    ${styles.sidebarItem} 
    ${isActive ? styles.sidebarItemActive : ''} 
    ${isDisabled ? styles.sidebarItemDisabled : ''}
    `}
    >
      <div className={styles.sidebarItemInner}>
        <SidebarItemInner title={title} isAiEnabled={isAiEnabled} isSoilSensor={isSoilSensor} />
      </div>
      {showAddSeasonButton && (
        <div className={styles.sidebarItemNav}>
          {showAddSeasonButton && <SidebarItemSeason onClickButton={onClickAddSeason} t={t} />}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
